import React, { FC } from 'react';
import DogListSortSelect from './DogListSortSelect';

interface SearchRowProps {
    setShowMobileFilterPanel: React.Dispatch<React.SetStateAction<boolean>>;
}

const SearchRow: FC<SearchRowProps> = ({ setShowMobileFilterPanel }) => {


    return (
        <div className="w-100 pb-3" id="searchRow">
            <div className="d-flex justify-content-between">
                <div className="col-6 d-flex flex-column">
                    <div className="me-1 flex-grow-1">
                        <div className="w-100 me-3 h-100 filterDiv">
                            <a type="button"
                                tabIndex={0}
                                className="btn btn-outline-secondary shadow-sm d-flex align-items-center justify-content-center fw-bold h-100 font-primary filter-btn"
                                onClick={() => setShowMobileFilterPanel(true)}
                            >
                                <i className="bi bi-sliders me-2"></i>
                                Filter
                            </a>
                        </div>
                        <div id="filterDiv" className="d-none my-3">
                            Filters Applied
                            <div className="d-flex flex-wrap mt-2" id="filters">
                                <a className="ms-2 clearAllLnk fw-bold">Clear All</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="location">
                </div>
                <div className="col-6 col-lg-3 ps-1">
                    <DogListSortSelect />
                </div>
            </div>
        </div>
    )
}

export default SearchRow;




















